export default "__VITE_ASSET__CL_5EBRT__"